<template>

  <div class="wrap">

    <Nav :activeId="activeId" />

    <!-- Part-1 -->
    <div class="section-one part-1-bg">
      <!-- <img src="../../img/about/part-1-bg.jpg" /> -->
      <!-- <div class="top-breadcrumb">
        <img src="../../img/about/nav-top.png" class="about" />
      </div> -->
      <div class="nav-bar">
        <!-- <div class="nav-bar_label">Explore Bänninger</div> -->
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span>关于班尼戈
        </div>
      </div>

      <div class="pic-info two">
        <img src="../../img/about/part-1-info-1.png" />
        <img src="../../img/about/part-1-info-2.png" />
      </div>
    </div>
    <!-- Part-2 -->
    <div class="section-one part-2-bg">
      <!-- <img src="../../img/about/part-2-bg.jpg" /> -->
      <div class="info type-2">
        <img src="../../img/about/part-2-info.png" class="info-2 type-2" />
      </div>
    </div>
    <!-- Part-3 -->
    <div class="section-one part-3-bg">
      <!-- <img src="../../img/about/part-3-bg.jpg" /> -->
      <div class="info">
        <img src="../../img/about/part-3-info.png" class="info-3" />
      </div>
    </div>
    <!-- Part-4 -->
    <div class="section-one part-4-bg">
      <!-- <img src="../../img/about/part-4-bg.jpg" /> -->
      <div class="info">
        <img src="../../img/about/part-4-info.png" class="info info-4" />
      </div>
    </div>
    <!-- Part-5 -->
    <div class="section-one part-5-bg">
      <!-- <img src="../../img/about/part-5-bg.jpg" /> -->
      <div class="info">
        <img src="../../img/about/part-5-info.png" class="info info-5" />
      </div>
    </div>
    <!-- Part-6 -->
    <div class="section-one part-6-bg">
      <!-- <img src="../../img/about/part-6-bg.jpg" /> -->
      <div class="info link">
        <img src="../../img/about/part-6-info.png" class="info-6" />
        <a href="/global-case" class="link1"></a>
        <a href="/china-case" class="link2"></a>
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.part-1-bg {
  width: 100%;
  height: 1321px;
  box-sizing: border-box;
  background-image: url('../../img/about/part-1-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-2-bg {
  width: 100%;
  height: 616px;
  box-sizing: border-box;
  background-image: url('../../img/about/part-2-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-3-bg {
  width: 100%;
  // height: 828px;
  height: 1098px;
  box-sizing: border-box;
  background-image: url('../../img/about/part-3-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-4-bg {
  width: 100%;
  height: 1051px;
  box-sizing: border-box;
  background-image: url('../../img/about/part-4-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-5-bg {
  width: 100%;
  height: 1126px;
  box-sizing: border-box;
  background-image: url('../../img/about/part-5-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-6-bg {
  width: 100%;
  height: 830px;
  box-sizing: border-box;
  background-image: url('../../img/about/part-6-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}

.section-one {
  // .block {
  //   // width: 1100px;
  // }
  .info {
    width: 1100px;
    height: auto;
    margin: 0 auto;
    position: absolute;
    left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
    // border: 1px solid red;
    &.link {
      padding-bottom: 10px;
      a {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 170px;
        height: 30px;
        // border: 1px solid red;
      }
      .link2 {
        left: 200px;
      }
    }
    &.type-2 {
      height: 194px;
      left: 0;
      right: 0;
      top: unset;
      transform: unset;
      bottom: 50px;
    }
    // .left {
      // position: absolute;
      // left: 0;
      // text-align: left;
    // }
  }
  .info-2 { width: 893px; height: 174px; }
  .info-3 { width: 1153px; height: 792px; }
  .info-4 { width: 1098px; height: 879px; }
  .info-5 { width: 1090px; height: 902px; }
  .info-6 { width: 1091px; height: 431px; }
}
.pic-info {
  width: 1100px;
  // height: 723px;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  // justify-content: center;
  justify-content: space-between;
  &.two {
    height: 940px;
    flex-direction: column;
  }
}
</style>